import { Text, Stack, Button, Group, Alert, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBusiness } from '../../../hooks';
import classes from '../Admin.module.css';

type ClientModalProps = {
  businessId: string | undefined;
};

export const CreateClientModal = ({ businessId }: ClientModalProps) => {
  const { t } = useTranslation();
  const { createClient } = useBusiness(businessId);
  const navigate = useNavigate();

  return (
    <Alert mt="md">
      <Title order={3}>{t<string>('createClient.title')}</Title>
      <Stack mt="lg">
        <Text>{t<string>('createClient.body.text1')}</Text>
        <Text>{t<string>('createClient.body.text2')}</Text>
        <Group justify="flex-end">
          <Button
            variant="outline"
            onClick={() => navigate('/admin')}
            className={classes['button']}
          >
            {t<string>('common.cancel')}
          </Button>

          <Button onClick={() => createClient({})}>
            {t<string>('createClient.confirm')}
          </Button>
        </Group>
      </Stack>
    </Alert>
  );
};
